import React, { useEffect } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { fetchQueue } from 'flow/actions/pbx-actions';
import QueueStatistics from 'flow/components/pbx/QueueStatistics';
import Loading from 'flow/components/ui-components/Loading';
import PbxQueueV2 from 'flow/pages/pbx/PbxQueueV2';
import CallHistoryDetailPageV2 from 'flow/components/pbx/v2/detail-page/CallHistoryDetailPageV2';
import CallContactCalendar from 'flow/route-components/CallContactCalendar';
import CallContactManagement from 'flow/route-components/CallContactManagement';
import OmniChannelAccountList from 'flow/route-components/OmniChannelAccountList';
import PbxProfiles from 'flow/route-components/PbxProfiles';
import PbxQueueCalendar from 'flow/route-components/PbxQueueCalendar';
import PbxQueueMember from 'flow/route-components/PbxQueueMember';
import PbxQueueMemberEdit from 'flow/route-components/PbxQueueMemberEdit';
import { PbxParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';
import { State } from 'flow/types/State';
import PbxQueueSettings from './PbxQueueSettings';

const PbxCallDetailPageV2 = () => (
    <CallHistoryDetailPageV2 pageType="pbx" segmentContext="PBX call detail" />
);

const PbxQueueRoutes = () => {
    const dispatch = useAppDispatch();
    const { entityKey } = useParams<PbxParams>();

    useEffect(() => {
        dispatch(fetchQueue(entityKey));
    }, [dispatch, entityKey]);

    const queueIsLoaded = useAppSelector(({ pbx }: State) =>
        pbx.hasIn(['queues', entityKey, 'key']),
    );

    if (!queueIsLoaded) {
        return <Loading />;
    }

    return (
        <Switch>
            <Route
                path={routes['pbx.queues.entityKey.statistics']}
                component={QueueStatistics}
            />
            <Route
                path={routes['pbx.queues.entityKey.settings']}
                component={PbxQueueSettings}
            />
            <Route
                path={routes['pbx.queues.queueKey.members.edit']}
                component={PbxQueueMemberEdit}
            />
            <Route
                path={routes['pbx.queues.queueKey.members']}
                component={PbxQueueMember}
            />
            <Route
                path={routes['pbx.queues.queueKey.connections']}
                component={OmniChannelAccountList}
            />
            <Route
                path={routes['pbx.queues.entityKey.profiles.calendar']}
                component={PbxQueueCalendar}
            />
            <Route
                path={routes['pbx.queues.entityKey.profiles']}
                component={PbxProfiles}
            />
            <Route
                path={
                    routes[
                        'pbx.queues.entityKey.number.callRecordKey.contactKey.calendar'
                    ]
                }
                component={CallContactCalendar}
            />
            <Route
                path={
                    routes['pbx.queues.entityKey.number.callRecordKey.contact']
                }
                component={CallContactManagement}
            />

            <Route
                path={routes['pbx.queues.queueKey.callRecordKey']}
                component={PbxCallDetailPageV2}
                exact={true}
            />

            <Route
                path={
                    routes[
                        'pbx.queues.entityKey.number.callRecordKey.contactKey'
                    ]
                }
                component={CallContactManagement}
            />

            <Route
                path={routes['pbx.queues.entityKey']}
                component={PbxQueueV2}
            />
        </Switch>
    );
};

export default PbxQueueRoutes;
